const node_env = globalThis.process?.env?.NODE_ENV;
export default node_env && !node_env.toLowerCase().startsWith('prod');
